// extracted by mini-css-extract-plugin
module.exports = {"UserProfileMenu":"UserProfileMenu_UserProfileMenu__30O-u"};